export default __webpack_public_path__ + "images/fi-3b522e7f272eee4009b2073b0b6735ac.svg";